import { apiConfig } from 'config';
import { fetchdata } from 'apis/FetchData';
import { handle420 } from 'apis/HandleError';
import moment from 'moment';

const default_from = moment().subtract(1, 'months').toISOString();

export function getCommissioningActions(status = 'all', fromStr = default_from, toStr = 'now', bundleId) {
  let url = apiConfig.commServiceSearch;
  let to = toStr;

  if (toStr === 'now') to = moment();

  let postBody = {
    status: status,
    from: fromStr,
    to: to
  };

  if (bundleId !== undefined) postBody.bundleId = bundleId;

  return fetchdata(url, {
    method: 'POST',
    body: JSON.stringify(postBody)
  }).catch((e) => {
    console.log('fetch data error = ' + e.message);
    switch (e.message) {
      case '420':
        handle420();
        break;
      default:
        throw e;
    }
    return;
  });
}
